<template>
    <v-row class="mx-1 pt-4">
        <invite-administrator v-model="showInviteAdministratorDialog"
                              headerColor="kbLightBlue"
                              type="administrador"
                              :title="$tc('general.inviteFinancier',1)">
        </invite-administrator>

        <v-col cols="12">
            <v-card color="kbWhite">
                <v-card-title>
                    <v-col cols="12" class="d-flex align-center">
                        <h4 class="font-weight-medium kbDarkBlueText--text">{{$t('general.billing')}}</h4>
                        <v-spacer></v-spacer>
                        <v-btn @click="showInviteAdministratorDialog = true"
                               class="mr-2"
                               color="mainButtons"
                               outlined>
                            {{$tc('general.inviteFinancier',2)}}
                        </v-btn>

                        <v-btn @click="openAddCreditCardDialog()"
                               class="mr-2"
                               color="mainButtons"
                               outlined
                               v-if="creditCards.length === 0">
                            {{$t('general.addCreditCard')}}
                        </v-btn>

                        <v-btn color="mainButtons"
                               dark
                               @click="openNewPaymentDialog()"
                               v-else>
                            {{$t('general.loadBalance')}}
                        </v-btn>
                    </v-col>
                </v-card-title>
                <v-card-text class="pt-0 px-2 pb-2">
                    <v-tabs center-active
                            background-color="kbWhite"
                            color="kbDarkBlueText"
                            centered
                            grow>
                        <v-tab to="/billing/usage" class="kbDarkBlueText--text">
                            {{$tc('general.usage',1)}}
                        </v-tab>

                        <v-tab to="/billing/transactions" class="kbDarkBlueText--text">
                            {{$tc('general.payment',3)}}
                        </v-tab>

                        <v-tab to="/billing/cards" class="kbDarkBlueText--text">
                            {{$t('general.paymentMethods')}}
                        </v-tab>
                    </v-tabs>
                    <router-view></router-view>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import InviteAdministrator from '@/pages/App/People/dialogs/InviteAdministrator.vue'
import notifications from '@/libs/notifications'
import { EventBus } from '@/eventBus'
import { mapState } from 'vuex'
export default {
  components: { InviteAdministrator },
  computed: {
    ...mapState({
      creditCards: state => state.payments.creditCards,
      selectedCompany: state => state.companies.selectedCompany
    })
  },
  data () {
    return {
      showInviteAdministratorDialog: false
    }
  },
  methods: {
    openAddCreditCardDialog () {
      if (!this.selectedCompany.email) {
        notifications.error(this.$t('general.completeBusinessDataBeforeAddingCreditCard'))
        return this.$router.push('/settings')
      }
      EventBus.$emit('openAddNewCreditCardDialog')
    },
    openNewPaymentDialog () {
      EventBus.$emit('chargeAccount')
    }
  }
}
</script>
